module.exports = __webpack_public_path__ + "media/packs/images/flags/GB-17b4a4179f25bf2fe841599236d45e47.png";